import { Heading } from '@nrg/design-system';
import type { FormEvent, ReactNode } from 'react';
import AuthError from './AuthError';
import styles from './AuthScreen.module.css';

interface AuthScreenProps {
  heading: ReactNode;
  subhead?: ReactNode;
  error?: ReactNode;
  footer?: ReactNode;
  onSubmit?: (event: FormEvent<HTMLFormElement>) => void;
  children: ReactNode;
}

export default function AuthScreen({
  heading,
  subhead,
  error,
  footer,
  onSubmit,
  children,
}: AuthScreenProps) {
  return (
    <form className={styles.form} onSubmit={onSubmit} noValidate>
      <header className={styles.headerBlock}>
        <Heading level={1}>{heading}</Heading>
        {subhead ? <p className={styles.subhead}>{subhead}</p> : null}
      </header>
      {error ? <AuthError>{error}</AuthError> : null}
      <div className={styles.fields}>{children}</div>
      {footer ? <div className={styles.footer}>{footer}</div> : null}
    </form>
  );
}
